import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Navbar from '../../Components/Navbar'
import BoxToken from '../../Components/BoxToken'
import Container from 'react-bootstrap/Container'
import { Redirect } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import './wallet.css'
import InsideMenu from '../../Components/InsideMenu'
import { create, sendSms } from '../../redux-flow/actions/wallet'
import CreateWallet from './createWallet'
import WalletSaldo from '../../Components/WalletSaldo'
import { Link } from 'react-router-dom'
import { fetchUserInfo } from '../../redux-flow/actions/users'
import { ReactComponent as  BRL } from '../../images/wallet/wallet_icons-01.svg'
import { ReactComponent as  BTC } from '../../images/wallet/wallet_icons-02.svg'
import { ReactComponent as  Conversao } from '../../images/wallet/wallet_icons-03.svg'
import { ReactComponent as  Extrato } from '../../images/wallet/wallet_icons-06.svg'
import { ReactComponent as  Flwt } from '../../images/wallet/flwt.svg'
import SideBar from '../../Components/SideBar'
const menu = [
    // {    
    //     titulo: "Depositar/Transferir",
    //     link: "/wallet/brl",
    //     disable: true,
    // },
    {    
        titulo: "BTC Enviar/Receber",
        link: "/wallet/btc",
    },
    // {    
    //     titulo: "Conversão",
    //     link: "/wallet/converter",
    //     disable: true,
    // },
    {    
        titulo: "Extrato",
        link: "/wallet/extrato",
        disable: true,
    },
]

class Wallet extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            password: '',
            loading: false,
            step: 1,
            modalToken: false
        }
    }  

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    componentDidMount() {
        const { onLoad, userid } = this.props
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
        if (onLoad && userid) {
            onLoad(this.props.userid)
        }
    }


    returnIcon = (type) => {
        switch (type){
            case 'Depositar/Transferir':
                return <BRL className="iconeWallet" />
            case 'BTC Enviar/Receber':
                return <BTC className="iconeWallet" />
            case 'Conversão':
                return <Conversao className="iconeWallet" />
            case 'Extrato':
                return <Extrato className="iconeWallet" />
            default:
                return <Flwt className="iconeWallet" />
        }
    }

    
        
    render() {

            const { logged, userLogged, isLoadingBalance, balance, userLoading, step, isLoading, createWallet, creationToken, reSendSms, userid, } = this.props
            if (userLogged) {
                return <Redirect to="/meusinvestimentos" />
            }
            return (   
                <>
                    <Navbar loggedArea={true}/>
                    {!logged ? <Redirect to="/login" /> : userLogged.cpf === null || userLogged.cep === null ? <Redirect to="/finalizar-cadastro" /> : (
                        userLogged.permissao === 0 || userLogged.permissao === 2 || userLogged.permissao === 4 ? <Redirect to="/wallet/lista-de-espera" /> :
                        <div>
                            <div className="section minhaContaWrapper">
                                <Container>
                                    <Row>
                                        <Col md={12} className="p-0">
                                            <InsideMenu />
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        
                        <div className="section insideSec">
                            <Container>
                                <Row>
                                    <Col md={2} className="p-0" style={{borderRight: '1px solid #F6F3FF'}}>
                                        <SideBar permissao={userLogged.permissao} nivelVerificacao={userLogged.nivelVerificacao} />
                                    </Col>
                                    <Col md={10} className="d-flex justify-content-center align-items-center flex-column">
                                        {/* <h3 className="tx-pink font-weight-bold">ACESSO EM BREVE</h3>
                                        <img src={walletImg} /> */}
                                        {!userLoading && (userLogged.Wallets.length === 0) ? 
                                            <>
                                                <CreateWallet permissao={userLogged.permissao} walletInfo={userLogged.Wallets} user={userLogged} reSendSms={() => reSendSms(userid)} isLoading={isLoading} createWallet={() => createWallet(this.props.userid)} step={step} token={creationToken} userid={this.props.userid} addressCreation={this.props.addressCreation} />
                                                <br /><br />
                                                <BoxToken />
                                            </> : 
                                            <>
                                            <WalletSaldo balance={balance} isLoading={isLoadingBalance} />

                                            <Row className='d-flex justify-content-center insideSec pt-0 w-100'>

                                                {menu.map (item => (
                                                    <Col className={ `mt-3 mb-2 colMenuWalletMobile ${['Depositar/Transferir','Conversão'].indexOf(item.titulo) > -1 ? 'opacidade' : ''} ` } >
                                                        <Link to={item.link}>
                                                            <div className='boxBotao'>
                                                                {this.returnIcon(item.titulo)}
                                                                <div>
                                                                    <div className="tituloBotao">{item.titulo}</div>
                                                                </div>

                                                            </div>
                                                        </Link>
                                                        <div className={` d-flex justify-content-center  umtext-black ${['Depositar/Transferir','Conversão'].indexOf(item.titulo) > -1 ? 'visible' : 'invisible'}`}>EM BREVE</div>

                                                    </Col>
                                                ))}
                                            </Row>
                                            </>
                                        }
                                    </Col>
                                </Row>
                            </Container> 
                        </div>
                        </div>
                        
                    )}
                    

                </>
            )
        }
    }

const mapStateToProps = state => ({
    logged: state.login.logged,
    userid: state.login.userid,
    userLoading: state.users.isLoading,
    userLogged: state.users.userLogged,
    step: state.wallet.step,
    addressCreation: state.wallet.addressCreation,
    isLoading: state.wallet.isLoading,
    isLoadingSMS: state.wallet.isLoadingSMS,
    creationToken: state.wallet.creationToken,
    userExpiration: state.wallet.userExpiration,
    walletLogged: state.wallet.walletLogged,
    completeToken: state.wallet_token.completeToken
})

const mapDispatchToProps = dispatch => ({
    createWallet: (id) => {
        dispatch(create(id))
    },
    reSendSms: (userid) => {
        dispatch(sendSms(userid))
    },
    onLoad: (id) => {
        dispatch(fetchUserInfo(id))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(Wallet)
